import { seededRandom } from "./seededRandom.js";
/**
 * Picks a random item from an array
 *
 * @param array - the array to be chosen from
 */

export const pick = array => array[Math.floor(seededRandom() * array.length)];